/*
 * Copyright (c) 2026. Orion Analytics.
 */

import AnalyticsCard from "./AnalyticsCard";

import HomeIndexChart from "./HomeIndexChart";
import SectorPerformanceCard from "./SectorPerformanceCard";
import TopGainersLosers from "./TopGainersLosers";

import IntradayHeatmap from "../stocks/intraday_heatmap";
import IntradayBubbleMap from "../stocks/intraday_pv";

export default function AnalyticsSection() {

    return (

        <section className="mb-24">

            <div className="mb-10">

                <h2 className="
                    text-4xl
                    font-bold
                    text-slate-900
                ">
                    Live Market Analytics
                </h2>

                <p className="
                    text-slate-600
                    mt-2
                ">
                    Real-time market intelligence powered by Orion Analytics
                </p>

            </div>

            {/* HERO MARKET DASHBOARD */}

            <div className="mb-10">

                <AnalyticsCard title="Market Dashboard">

                    <HomeIndexChart />

                </AnalyticsCard>

            </div>

            {/* SUMMARY CARDS */}

            <div className="
                grid
                md:grid-cols-2
                xl:grid-cols-2
                gap-6
                mb-10
            ">

                <AnalyticsCard title="Top Movers">

                    <TopGainersLosers />

                </AnalyticsCard>

                <AnalyticsCard title="Sector Leaders">

                    <SectorPerformanceCard />

                </AnalyticsCard>

            </div>

        </section>
    );
}